<template>
  <div>
    <img v-if="printMode" class="ui fluid image" :src="image" :title="label"/>
    <div v-else ref="widget"></div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import _ from 'lodash';

export default {
  props: {
    title: {
      type: String
    },
    name: {
      type: String
    },
    dataSource: {
      type: Array,
      default: () => []
    },
    dataModel: {
      type: Array,
      default: () => []
    },
    dataTextField: {
      type: String,
      default: 'name'
    },
    dataValueField: {
      type: String,
      default: 'value'
    },
    format: {
      type: String,
      default: '{0:n2}'
    },
    height: {
      type: Number,
      default: 340
    },
    colors: {
      type: Array,
      default: () => ['#1ABC9C', '#3498DB', '#9B59B6', '#34495E', '#E74C3C', '#E67E22', '#F1C40F', '#ECF0F1']
    },
    printMode: {
      type: Boolean
    }
  },

  data () {
    const dataSource = new kendo.data.HierarchicalDataSource({
      data: this.dataSource
    });

    const config = {
      theme: 'bootstrap',
      dataSource,
      textField: this.dataTextField,
      valueField: this.dataValueField,
      colors: this.colors,
      template: _(this.dataModel)
        .map(i => `#= kendo.format("${i.format || '{0}'}" , dataItem.${i.field}) || text #`)
        .join('<br/>')
    };

    return {
      config,
      widget: undefined
    };
  },

  methods: {
    exportChart () {
      html2canvas(this.$refs.widget, {
        onrendered: (canvas) => {
          kendo.saveAs({
            dataURI: canvas.toDataURL('image/png'),
            fileName: 'chart.png'
          });
        }
      });
    },

    generateImage () {
      html2canvas(this.$refs.widget, {
        onrendered: (image) => {
          this.image = image;
        }
      });
    },

    setupToolTip () {
      try {
        return new kendo.ui.Tooltip(this.$refs.widget, {
          filter: '.k-leaf,.k-treemap-title',
          position: 'center',
          showAfter: 750,
          background: '#fff',
          color: '#303030',
          border: {
            color: '#bdbdbd'
          },
          content: (e) => {
            const item = this.widget.dataItem(e.target.closest('.k-treemap-tile'));
            return `
                          <p align='left'>
                              ${_(this.dataModel).map(i => `<b>${i.title}:</b> ${kendo.format(i.format || '{0}', item[i.field])}`).join('<br/>')}
                          </p>`;
          }
        });
      } catch (err) {
        console.log(err);
      }
    },

    resize () {
      this.widget.resize();
    }
  },

  mounted () {
    this.widget = new kendo.dataviz.ui.TreeMap(this.$refs.widget, this.config);
    this.setupToolTip();
    window.addEventListener('resize', this.resize);
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.resize);
  },

  destroyed () {
    this.widget.destroy();
  },

  watch: {
    printMode () {
      this.generateImage();
    },

    dataSource (val) {
      const template = _(this.dataModel)
        .map(i => `#= kendo.format("${i.format || '{0}'}" , dataItem.${i.field}) || text #`)
        .join('<br/>');
      this.widget.setOptions({ template });

      const dataSource = new kendo.data.HierarchicalDataSource({ data: val });
      this.widget.setDataSource(dataSource);
    },

    dataTextField (val) {
      const textField = Object.assign({}, this.config.textField, {
        textField: val
      });
      this.widget.setOptions({ textField });
    },

    dataValueField (val) {
      const valueField = Object.assign({}, this.config.valueField, {
        valueField: val
      });
      this.widget.setOptions({ valueField });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
